import { SerializedConstructor } from '@langchain/core/load/serializable';

import {
  MODEL_DEFAULT_KWARGS,
  MODEL_SECRETS,
} from '@/Pages/Playground/Playground.constants';

export function getSettingsFromManifest(manifest?: SerializedConstructor) {
  if (!manifest) return {};

  return 'last' in manifest.kwargs
    ? manifest?.kwargs.last.kwargs.bound ?? manifest?.kwargs.last
    : manifest;
}

export function getSettingsFromModelManifest(manifest: SerializedConstructor) {
  return manifest.kwargs.bound ?? manifest;
}

export function getExtraParams(model_kwargs?: SerializedConstructor) {
  if (!model_kwargs) return {};
  const model_id = model_kwargs.id.join('/');

  return Object.fromEntries(
    Object.entries(model_kwargs.kwargs as Record<string, any>).filter(
      ([key]) =>
        !Object.keys(MODEL_DEFAULT_KWARGS[model_id] || {})
          .concat(
            Object.keys(MODEL_SECRETS[model_id] || {}).map(
              (key) => key.split('.')[0]
            )
          )
          .includes(key)
    )
  );
}
